var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch",value:({
    left: function () { return _vm.swipe('left'); },
    right: function () { return _vm.swipe('right'); },
  }),expression:"{\n    left: () => swipe('left'),\n    right: () => swipe('right'),\n  }"}],staticClass:"process-map-container inherit-height",staticStyle:{"overflow-y":"scroll"}},[_c('map-top',{staticClass:"mb-3"}),_c('map-container',{staticClass:"flex-grow-1"}),_c('map-bottom',{staticClass:"mt-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }